<template>
    <div class="columns is-centered">
        <div class="column is-6-desktop is-12-mobile is-12-tablet">
            
            <div class="has-text-centered">
                <p class="is-size-1">👏</p>
            </div>

            <div class="field has-text-centered">
                <label class="label is-size-4 heading-txt"><b>Congratulations!<br> We just need a bit more information</b></label>
            </div>
                
            <div v-if="(!customer.firstName || !customer.lastName) || hasNewCustomerName(customer.firstName, customer.lastName)" class="field space-bottom">
                <div class="control">
                    <input autofocus class="input text-input" type="text" placeholder="First & Last Name" v-model="fullName">
                </div>
            </div>


            <div v-if="!customer.email" class="field space-bottom">
                <div class="control">
                    <input autofocus class="input text-input" type="text" placeholder="Email" v-model="email">
                </div>
            </div>

            <div class="flex-column control-group">
                <template>
                    <div class="flex-full-width">
                        <label class="control control--checkbox cust-radio">
                            <input type="checkbox" 
                                @click="receiveOffers = !receiveOffers" 
                                v-model = "receiveOffers"
                                />
                            <div class="control__indicator checkbox"></div>
                            <span>Receive Email Offers</span>
                            <p class="is-size-7 has-text-grey-light">can be turned {{receiveOffers ? "off" : "on"}} at any time from your profile</p>
                        </label>
                    </div>
                </template>
            </div>

            <div class="has-text-centered space-bottom">
                <BaseButton title="Start Ordering"
                    :classNames="['button--modifier']"
                    @click.native="submitRequest" />
            </div>

            <p v-if="errMsgs.length">Error: {{errMsgs.join(", ")}}</p>
            <p>{{msg}}</p>
        </div>
    </div>
</template>


<script>
import { ACCOUNT, LOCATION } from "@/stores/defs";
import { mapGetters, mapActions } from "vuex";
import AddressChooser from "@/components/checkout/AddressChooser";
import customerService from "@/services/customer.service";
import { splitName, hasNewCustomerName } from '@/utils/helper.functions';
import FormValidator from '@/utils/FormValidator';
import { isArray } from 'lodash';
import EventBus from '@EventBus';

export default {
    props: {
        routeTo: {
            type: String,
            default: "/",
        },
    },
    computed: {
        ...mapGetters({
            customer: ACCOUNT.GET_CUSTOMER,
			location: LOCATION.GET_LOCATION,
			guestEmail: ACCOUNT.GET_GUEST_EMAIL,
			guestName: ACCOUNT.GET_GUEST_NAME,
        })
    },
    data() {
        return {
            firstName: "",
            lastName: "",
            fullName: "",
            email: "",
            errMsgs: [],
            msg: "",
            receiveOffers: true
        };
    },
    components: {
        "address-chooser": AddressChooser
    },
    methods: {
        hasNewCustomerName,
        isValidEmail: FormValidator.validateEmail,
        ...mapActions({
            updateCustomer: ACCOUNT.UPDATE_CUSTOMER
        }),
        submitRequest() {
            const apiReq = {
                lb: this.location.id,
                c: {
                    base: this.customer.id,
                    phone: this.customer.phone,
                    receive_offers: this.receiveOffers
                }
            };
            this.errMsgs = [];

            // create first and last name
            const names = splitName(this.fullName.trim());

            // if customer state names or input names are invalid
            if ( (!names && (!(this.customer.firstName || this.customer.lastName) || hasNewCustomerName(this.customer.firstName, this.customer.lastName))) ||
                names && hasNewCustomerName(names.firstName, names.lastName)) {
                this.errMsgs.push("Please enter a valid name");
            } else if (!this.customer.email && !this.isValidEmail(this.email)) {
				this.errMsgs.push("Please enter a valid email");
            } else {
                if (names) {
                    this.firstName = names.firstName;
                    this.lastName = names.lastName;
                }

                if (this.email) {
                    apiReq.c.email = this.email;
                }

                if (!this.errMsgs.length) {

                    if (this.firstName) {
                        apiReq.c.firstname = this.firstName;
                    }

                    if (this.lastName) {
                        apiReq.c.lastname = this.lastName;
                    }

                    customerService
                        .editProfile(apiReq)
                        .then(res => {
							const body = res.data.body;
							if (isArray(body.errors)) {
								const errors = body.errors;
								if (errors.length > 0) {
									this.errMsgs = errors;
									return;
								}
                            }
            
                            if (
                                res.data.message === "Customer save!" &&
                                res.data.body.customer.firstname ||
                                res.data.body.customer.lastname &&
                                res.data.body.customer.email
                            ) {
                                this.updateCustomer({
                                    firstName: res.data.body.customer.firstname,
                                    lastName: res.data.body.customer.lastname,
                                    email: res.data.body.customer.email,
                                    receiveOffers: res.data.body.customer.receive_offers
                                });
                                this.msg = "Profile successfully updated";
                                this.errMsgs = [];

								// TODO needs better route handling, prop gets set to default
								let routePath = this.routeTo;
								if (this.$route.name === 'checkout') {
									routePath = '/checkout';
								}
								if (routePath) {
                                    this.$router.push({ path: routePath });
                                }
								this.$modal.hide('contentModal');
								EventBus.$emit('customer-update');
                            } else {
                                this.errMsgs.push("an error occured");
                            }
                        })
                        .catch(err => {
                            this.errMsgs.push(err.message);
                        });
                }
            }
        }
	},
	mounted() {
		const guestEmail = this.guestEmail;
		const guestName = this.guestName || '';
		this.fullName = guestName;
        this.email = guestEmail;

        if (this.customer && this.customer.id && this.guestName === '') {
			const first = this.customer.firstName || '';
			const last = this.customer.lastName || '';
            this.fullName = `${first} ${last}`.trim();
        }
	}
};
</script>

<style lang="scss" scoped>
.space-bottom {
    margin-bottom: 1em;
}
</style>



// WEBPACK FOOTER //
// src/components/auth/LinkUser.vue